// REVIEW This maps Cognito exception codes with user-facing i18n messages.
// It probably shouldn't be here.
export const COGNITO_ERRORS_MAP = {
  ExpiredCodeException: 'error:network',
  LimitExceededException: 'error:limit-exceeded',
  CodeMismatchException: 'error:code-mismatch',
}
